<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-card>
                        <v-app-bar dark color="accent">
                            <v-icon class="mr-3">mdi-filter</v-icon>
                            <v-toolbar-title>Filters</v-toolbar-title>
                        </v-app-bar>
                        <v-container fluid>
                            <v-row dense>
                                <!--<v-col cols="12" md="2" lg="2">
                                    <v-select class="test-class"
                                              :items="data.financingType"
                                              chips
                                              small-chips
                                              deletable-chips
                                              label="Financing Type"
                                              solo
                                    />
                                </v-col>-->

                                <v-col cols="12" md="2" lg="2">
                                    <v-select
                                            :items="data.schemeDropDownData"
                                            chips
                                            small-chips
                                            deletable-chips
                                            label="Product"
                                            solo

                                    />
                                </v-col>
                                <v-col cols="12" md="2" lg="2">
                                    <v-select
                                            :items="data.financingAmount"
                                            chips
                                            small-chips
                                            deletable-chips
                                            label="Financing Amount Range"
                                            solo

                                    />
                                </v-col>
                                <v-col cols="12" md="2" lg="2">
                                    <v-select
                                            :items="data.gfiStatus"
                                            chips
                                            small-chips
                                            deletable-chips
                                            label="GFI Status"
                                            solo

                                    />
                                </v-col>
                                <v-col cols="12" md="2" lg="2">
                                    <v-select
                                            :items="data.completionYear"
                                            chips
                                            small-chips
                                            deletable-chips
                                            label="Year"
                                            solo

                                    />
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="4" md="10"></v-col>
                                <v-col cols="8" md="2">
                                    <v-btn color="primary" dark>Filter</v-btn>
                                    <v-btn color="accent" class="ml-3" dark>Reset</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-container fluid>
            <v-row>
                <v-col>
                    <v-card>
                        <v-app-bar dark color="accent">
                            <v-icon class="mr-3">mdi-account-group</v-icon>
                            <v-toolbar-title>Customers</v-toolbar-title>
                            <v-row justify="end">
                                <v-dialog max-width="450" persistent v-model="appliedDialog">
                                    <template v-slot:activator="{ on }">
                                        <v-btn color="secondary" dark v-on="on"
                                        >View Applied Filters
                                        </v-btn
                                        >
                                    </template>
                                    <v-card>
                                        <v-card-title class="headline"
                                        >Filters Applied
                                        </v-card-title
                                        >
                                        <v-card-text>
                                            <v-simple-table>
                                                <template v-slot:default>
                                                    <tbody>
                                                    <!--<tr>
                                                        <td>Financing Types</td>
                                                        <td>:</td>
                                                        <td>All Financing Types</td>
                                                    </tr>-->
                                                    <tr>
                                                        <td>Product</td>
                                                        <td>:</td>
                                                        <td>All Products</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Financing Amount Range</td>
                                                        <td>:</td>
                                                        <td>All Financing Amount</td>
                                                    </tr>
                                                    <tr>
                                                        <td>GFI Status</td>
                                                        <td>:</td>
                                                        <td>All Status</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Year</td>
                                                        <td>:</td>
                                                        <td>All Years</td>
                                                    </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-card-text>
                                        <v-card-actions>
                                            <div class="flex-grow-1"></div>
                                            <v-btn @click="appliedDialog = false" color="accent darken-1" text
                                            >Close
                                            </v-btn
                                            >
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-row>
                        </v-app-bar>
                        <v-card-title>
                            <v-row>
                                <v-col md="8"/>
                                <v-text-field label="Search"/>
                                <v-btn class="ma-2" color="primary" dark>
                                    <v-icon dark>mdi-magnify</v-icon>
                                </v-btn>
                            </v-row>
                        </v-card-title>
                        <v-row class="ml-3">
                <span :key="index" v-for="(headers, index) in headers">
                  <v-col v-if="headers.toggle">
                    <v-checkbox :label="headers.text" color="primary" v-model="headers.selectedCheckbox"/>
                  </v-col>
                </span>
                        </v-row>
                        <v-row dense>

                            <v-col>
                                <v-data-table
                                        :headers="filteredHeaders"
                                        :items="data.tableDataWrapper.rowData"
                                        :search="search"
                                        :items-per-page=10
                                        :footer-props="{
                                            'items-per-page-options': [10],
                                            'show-current-page':true
                                        }"
                                >
                                    <template v-slot:item.action="{ item }">
                                        <v-progress-circular v-if="checkItemArray.indexOf(item.officer_id)>-1"
                                                             indeterminate
                                                             :size="18"
                                                             color="primary"
                                                             class="mr-2"
                                        />

                                        <v-icon v-else small class="mr-2" @click="downloadAccessToken(item.officer_id)"
                                                color="primary">mdi-file-download
                                        </v-icon>
                                        <v-icon small class="mr-2" @click="generateAccessToken" color="black">
                                            mdi-email
                                        </v-icon>
                                    </template>
                                    <template v-slot:item.test_taker_id="{ item }">

                                        <span v-if="item.gfi_rating>=740 && item.gfi_rating<=800">Safe</span>
                                        <span v-else-if="item.gfi_rating>=580 && item.gfi_rating<=739">Low Risk</span>
                                        <span v-else-if="item.gfi_rating>=420 && item.gfi_rating<=579">Moderate Risk</span>
                                        <span v-else-if="item.gfi_rating>=300 && item.gfi_rating<=419">Risky</span>
                                        <span v-else-if="item.gfi_rating>=200 && item.gfi_rating<=299">Unacceptable Risk</span>
                                        <span v-else>-</span>

                                    </template>
                                    <template v-slot:item.report_available="{ item }">
                                        <span v-if="item.report_available">
                                            <v-btn href="pdf/bank/report.pdf" target="_blank" icon
                                                   text>
                                                <v-icon color="green">mdi-file-download</v-icon>
                                            </v-btn>
                                        </span>
                                        <span v-else>
                                            <v-btn disabled icon text>
                                                <v-icon>mdi-file-download</v-icon>
                                            </v-btn>
                                        </span>
                                    </template>
                                    <template v-slot:item.loan_amount="{ item }">
                                        <span>{{item.loan_amount.toLocaleString()}}</span>
                                    </template>

                                    <template v-slot:item.application_status="{ item }">
                                        <span>{{item.application_status}}</span>
                                        <v-icon v-show="!isNonInteractive" small class="mr-2" @click="viewApplicationStatus">mdi-pencil
                                        </v-icon>
                                    </template>

                                    <template v-slot:item.details="{ item }">
                                        <v-icon small class="mr-2" @click="editItem(item)">mdi-square-edit-outline
                                        </v-icon>
                                    </template>
                                    <template v-slot:item.scoring="{ item }">
                                        <v-icon small class="mr-2" @click="generateScore(item)">mdi-calculator</v-icon>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
            <v-dialog max-width="650" persistent v-model="generateAccessTokenDialog">
                <validation-observer ref="obs" v-slot="{ invalid, validated, passes, validate }">

                    <v-card>
                        <v-card-title class="headline" style="textColor: '#1A68A4'">Send GFI Access ID</v-card-title>
                        <hr>
                        <v-card-text class="mt-5">
                            <v-form ref="form">
                                <!--              <v-btn color="success">Generate Access Token</v-btn>-->
                                <!--              <v-btn color="info" class="ml-3">Download</v-btn>-->
                                <v-switch inset v-model="emailCheckBox" :label="`Email`"/>
                                <validation-provider name="Email" :rules="{ required: emailCheckBox, email: true }"
                                                     v-slot="{ errors, failedRules }">
                                    <v-text-field v-model="generateModel.email"
                                                  label=""
                                                  :disabled="!emailCheckBox"
                                                  :error-messages="$translatedErrorMessages(failedRules,'Email')"
                                                  placeholder="Email Address" solo flat outlined/>
                                </validation-provider>
                                <v-switch inset v-model="smsCheckBox" :label="`SMS`"/>
                                <validation-provider name="SMS" :rules="{ required: smsCheckBox, numeric: true }"
                                                     v-slot="{ errors, failedRules }">
                                    <v-text-field v-model="generateModel.sms"
                                                  label=""
                                                  :disabled="!smsCheckBox"
                                                  :error-messages="$translatedErrorMessages(failedRules,'SMS')"
                                                  placeholder="Phone Number" solo flat outlined/>
                                </validation-provider>
                                <!--              <v-text-field label="SMS" required></v-text-field>-->
                                <!--              <v-btn color="info">Send</v-btn>-->
                            </v-form>
                        </v-card-text>
                        <v-card-actions align="right">
                            <v-spacer></v-spacer>
                            <v-btn @click="clear">Cancel</v-btn>
                            <v-btn color="primary" :disabled="sendButtonDisabled" @click="passes(successAccessToken)">
                                Send
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </validation-observer>
            </v-dialog>
            <v-dialog max-width="450" persistent v-model="dialog">
                <validation-observer ref="obs" v-slot="{ invalid, validated, passes, validate }">
                    <v-card>
                        <v-card-title class="headline" style="textColor: '#1A68A4'">Edit Customer Information
                        </v-card-title>
                        <v-card-text>
                            <form>
                                <span>Gender</span>
                                <validation-provider name="Gender" rules="required" v-slot="{ errors, failedRules }">
                                    <v-select v-model="edit.gender"
                                              :items="data.gender"
                                              label="Gender"
                                              placeholder="Select gender"
                                              :error-messages="$translatedErrorMessages(failedRules,'Gender')"
                                              solo/>
                                </validation-provider>
                                <span>Ethnicity</span>
                                <validation-provider name="Ethnicity" rules="required" v-slot="{ errors, failedRules }">
                                    <v-select v-model="edit.ethnicity"
                                              :items="data.ethinicity"
                                              label="Ethnicity"
                                              placeholder="Select ethnicity"
                                              :error-messages="$translatedErrorMessages(failedRules,'Ethnicity')"
                                              solo/>
                                </validation-provider>


                                <span>Company Name</span>
                                <validation-provider name="Company Name"
                                                     :rules="{ required:true, max:80, regex: /^[A-Za-z0-9_.&()'\s-]+$/ }"
                                                     v-slot="{ errors, failedRules }">
                                    <v-text-field v-model="edit.companyName"
                                                  label="Company Name"
                                                  :error-messages="$translatedErrorMessages(failedRules,'Company Name')"
                                                  placeholder="Company Name" solo flat outlined/>
                                </validation-provider>


                                <span>Product</span>
                                <validation-provider name="Product" rules="required"
                                                     v-slot="{ errors, failedRules }">

                                    <v-select v-model="edit.schemeDropdown"
                                              :items="data.schemeDropDownData"
                                              placeholder="Select Product"
                                              :error-messages="$translatedErrorMessages(failedRules,'scheme')"
                                              solo/>
                                </validation-provider>

                                <span>Business Category</span>
                                <validation-provider name="Business Category" rules="required"
                                                     v-slot="{ errors, failedRules }">

                                    <v-select v-model="edit.businessCategory"
                                              :items="data.businessCategory"
                                              placeholder="Select Business Category"
                                              :error-messages="$translatedErrorMessages(failedRules,'businessCategory')"
                                              solo/>
                                </validation-provider>

                                <span>Type of Business</span>
                                <validation-provider name="Type of Business" rules="required"
                                                     v-slot="{ errors, failedRules }">

                                    <v-select v-model="edit.typeOfBusiness"
                                              :items="data.typeOfBusiness"
                                              placeholder="Select type of Business"
                                              :error-messages="$translatedErrorMessages(failedRules,'typeOfBusiness')"
                                              solo/>
                                </validation-provider>
                                <span>Financing Amount</span>
                                <validation-provider name="Financing Amount"
                                                     rules="required|numeric|min_value:10000|max_value:2500000"
                                                     v-slot="{ errors, failedRules }">
                                    <v-text-field
                                            value="10.00"
                                            prefix="RM"
                                            solo flat outlined
                                            :error-messages="$translatedErrorMessages(failedRules,'Financing Amount')"
                                            v-model="edit.financingAmount"
                                    >
                                    </v-text-field>
                                </validation-provider>
                                <span>Financing Tenure</span>
                                <validation-provider name="Financing Tenure"
                                                     rules="required|numeric|min_value:1|max_value:84"
                                                     v-slot="{ errors, failedRules }">
                                    <v-text-field v-model="edit.financingTenure"
                                                  label="Financing Tenure"
                                                  :error-messages="$translatedErrorMessages(failedRules,'Financing Tenure')"
                                                  placeholder="123" solo flat outlined/>
                                </validation-provider>

                                <span>Branch</span>
                                <validation-provider name="Branch" rules="required" v-slot="{ errors, failedRules }">
                                    <v-select v-model="edit.region"
                                              :items="data.branch"
                                              placeholder="Select Branch"
                                              :error-messages="$translatedErrorMessages(failedRules,'branch')"
                                              solo/>
                                </validation-provider>
                            </form>
                        </v-card-text>
                        <v-card-actions align="right">
                            <v-spacer></v-spacer>
                            <v-btn @click="clear">Cancel</v-btn>
                            <v-btn color="primary" @click="passes(updatedItem)">Update</v-btn>
                        </v-card-actions>
                    </v-card>
                </validation-observer>

            </v-dialog>
            <v-dialog max-width="450" persistent v-model="deletedDialog">
                <v-card>
                    <v-card-title class="headline">Remove Customer</v-card-title>
                    <v-card-text>Are you sure you want to remove {{clickedItem.company_name}} ?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="deletedDialog=false" right>Cancel</v-btn>
                        <v-btn color="primary" class="mr-4" dark @click="deletedItemSuccess" right>Yes</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog max-width="450" persistent v-model="generateScoreDialog">
                <v-card>
                    <v-card-title class="headline">Generate GFI Credit Score</v-card-title>
                    <v-card-text>
                        Are you sure you want to generate GFI Credit Score for this customer?
                        <br/>Please note that you will not be able to change the customer details after
                        scores have been generated.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="generateScoreDialog=false" right>Cancel</v-btn>
                        <v-btn color="primary" class="mr-4" dark @click="generateScoreDialogSuccess" right>Yes</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog max-width="450" persistent v-model="viewApplicationStatusDialog">
                <v-card>
                    <v-card-title class="headline">Application Status</v-card-title>
                    <v-card-text>
                        <v-select
                                :items="data.applicationStatus"
                                v-model="applicationStatus"
                                chips
                                small-chips
                                deletable-chips
                                label="Please select application status"
                                solo>
                        </v-select>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="accent" class="mr-4" dark @click="viewApplicationStatusDialog=false" right>Close
                        </v-btn>
                        <v-btn color="primary" @click="viewApplicationStatusDialog=false">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
        <v-container v-show="!isNonInteractive" fluid>
            <v-app-bar dark color="accent">
                <v-icon class="mr-3">mdi-map-legend</v-icon>
                <v-toolbar-title>Legend</v-toolbar-title>
            </v-app-bar>
            <v-card class="pl-5 pt-4 pb-4">
                <v-row>
                    <!--<v-col md="2" cols="6" class="d-inline-flex">
                        <v-col md="1" col="2">
                            <v-icon color="primary">mdi-file-download</v-icon>
                        </v-col>
                        <v-col md="11" cols="10"> Download Access Id</v-col>
                    </v-col>
                    <v-col md="2" cols="6" class="d-inline-flex">
                        <v-col md="1" cols="2">
                            <v-icon color="black">mdi-email</v-icon>
                        </v-col>
                        <v-col md="11" cols="10"> Email Access Id</v-col>
                    </v-col>-->
                    <v-col md="2" cols="6" class="d-inline-flex">
                        <v-col md="1" cols="2">
                            <v-icon>mdi-square-edit-outline</v-icon>
                        </v-col>
                        <v-col md="11" cols="10"> Edit Customer information</v-col>
                    </v-col>
                    <v-col md="2" cols="6" class="d-inline-flex">
                        <v-col md="1" cols="2">
                            <v-icon>mdi-calculator</v-icon>
                        </v-col>
                        <v-col md="11" cols="10"> Generate GFI Credit Score
                        </v-col>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
        <v-snackbar
                v-model="updated"
                color="success"
                :right="'right'"
                :top="'top'"
                :timeout=2000
        >Successfully Updated.
        </v-snackbar>
        <v-snackbar
                v-model="generateScoreSnackbar"
                color="success"
                :right="'right'"
                :top="'top'"
                :timeout=2000
        >Successfully Triggered Generate Scores.
        </v-snackbar>
        <v-snackbar
                v-model="deletedSnackbar"
                color="success"
                :right="'right'"
                :top="'top'"
                :timeout=2000
        >Successfully Removed.
        </v-snackbar>
    </div>
</template>

<script>

    // eslint-disable-next-line no-unused-vars
    const data = require('../data/sample')
    export default {
        name: 'First',
        components: {},
        data() {
            return {
                data,
                search: '',
                emailCheckBox: false,
                smsCheckBox: false,
                applicationStatus: false,
                viewApplicationStatusDialog: false,
                edit: {
                    gender: '',
                    ethnicity: '',
                    companyName: '',
                    businessCategory: '',
                    typeOfBusiness: '',
                    financingAmount: '',
                    financingTenure: null,
                    region: '',
                    orr: ''
                },
                generateModel: {
                    email: '',
                    sms: ''
                },
                dialog: false,
                appliedDialog: false,
                deletedDialog: false,
                generateAccessTokenDialog: false,
                generateScoreDialog: false,
                updated: false,
                deletedSnackbar: false,
                generateScoreSnackbar: false,
                table: {
                    tableData: [],
                    totalLength: 0
                },
                items: [
                    {text: 'Home', disabled: true, href: 'breadcrumbs_dashboar'},
                    {text: 'Manage', disabled: true, href: 'breadcrumbs_link_1'}
                ],
                headers: [
                    {
                        text: 'Sl. No', align: 'center', sortable: false, value: 'id', selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'Business Registration (BR) No.',
                        align: 'center',
                        sortable: false,
                        value: 'br_number', selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'Company Name',
                        align: 'center',
                        sortable: false,
                        value: 'company_name',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'Identification Number (ID)',
                        align: 'center',
                        sortable: false,
                        value: 'id_number',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'Customer Name',
                        align: 'center',
                        sortable: false,
                        value: 'full_name',
                        selectedCheckbox: false,
                        toggle: true
                    },
                    {
                        text: 'Staff ID No.',
                        align: 'center',
                        sortable: false,
                        value: 'officer_id',
                        selectedCheckbox: true,
                        toggle: true
                    },
                    {
                        text: 'Product',
                        align: 'center',
                        sortable: false,
                        value: 'scheme_name', selectedCheckbox: true,
                        toggle: true
                    },
                    {
                        text: 'Financing Amount Requested (RM)',
                        align: 'center',
                        sortable: false,
                        value: 'loan_amount',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'GFI Completion Date',
                        align: 'center',
                        sortable: false,
                        value: 'gfi_completion_date', selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'GFI Status',
                        align: 'center',
                        sortable: false,
                        value: 'gfi_status', selectedCheckbox: true,
                        toggle: false
                    },
                    /*{
                        text: 'GFI Access ID',
                        align: 'center',
                        sortable: false,
                        value: 'action', selectedCheckbox: true,
                        toggle: false
                    },*/
                    {
                        text: 'Update Details',
                        align: 'center',
                        sortable: false,
                        value: 'details', selectedCheckbox: true,
                        toggle: false,
                        hideForNonInteractive: true
                    },
                    {
                        text: 'Generate GFI Credit Score',
                        align: 'center',
                        sortable: false,
                        value: 'scoring', selectedCheckbox: true,
                        toggle: false,
                        hideForNonInteractive: true
                    },
                    {
                        text: 'GFI Credit Score',
                        align: 'center',
                        sortable: false,
                        value: 'gfi_rating',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'GFI Rating',
                        align: 'center',
                        sortable: false,
                        value: 'test_taker_id',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'GFI Report',
                        align: 'center',
                        sortable: false,
                        value: 'report_available',
                        selectedCheckbox: true,
                        toggle: false
                    },
                    {
                        text: 'Application Status',
                        align: 'center',
                        sortable: false,
                        value: 'application_status', selectedCheckbox: true,
                        toggle: false
                    }
                ],
                checkItemArray: [],
                clickedItem: {}
            }
        },
        methods: {
            generateAccessToken: function () {
                this.generateAccessTokenDialog = true
            },
            editItem: function () {
                this.dialog = true
            },
            updatedItem: function () {
                this.dialog = false
                this.updated = true
            },
            deleteItem: function (item) {
                this.deletedDialog = true
                this.clickedItem = item
            },
            deletedItemSuccess: function () {
                this.deletedDialog = false
                this.deletedSnackbar = true
            },
            generateScore: function (item) {
                this.generateScoreDialog = true
                this.clickedItem = item
            },
            generateScoreDialogSuccess: function () {
                this.generateScoreDialog = false
                this.generateScoreSnackbar = true
            },
            viewApplicationStatus() {
                this.viewApplicationStatusDialog = true

            },
            downloadAccessToken: function (applicationId) {

                this.checkItemArray.push(applicationId)

                var trigger = setInterval(() => {
                    if (!this.checkItemArray.isEmpty) {
                        this.checkItemArray.shift()

                    } else {
                        clearInterval(trigger)
                    }
                }, 1000);

            },
            successAccessToken: function () {
                this.clear()
            },
            clear: function () {
                this.edit = {
                    gender: '',
                    ethnicity: '',
                    companyName: '',
                    businessCategory: '',
                    financingAmount: '',
                    financingTenure: null,
                    region: '',
                    orr: ''
                }

                this.generateModel = {
                    email: ''
                }
                requestAnimationFrame(() => {
                    this.$refs.obs.reset();
                });
                this.generateAccessTokenDialog = false
                this.dialog = false
            }
        },
        computed: {
            filteredHeaders() {
                return this.headers.filter(function(h){
                    let hideForNonInteractive = (localStorage.getItem("bfeusertype") && localStorage.getItem("bfeusertype")==='noninteractive') && h.hideForNonInteractive
                    return h.selectedCheckbox && !hideForNonInteractive
                } )
            },
            sendButtonDisabled() {
                // if(this.emailCheckBox && this.smsCheckBox){
                //     return false;
                // }else if(this.emailCheckBox || this.smsCheckBox){
                //     return true;
                // }else{
                //     return false;
                // }
                return (!this.emailCheckBox && !this.smsCheckBox)
            },
            isNonInteractive() {
              return (localStorage.getItem("bfeusertype") && localStorage.getItem("bfeusertype")==='noninteractive')
            }
        }
    }
</script>

<style scoped>
    .v-label {
        color: rgba(255, 255, 255, 1);
    }
</style>
